export const ISOLATED_SITE_PREVIEWS_META_NAME = 'isolated-site-previews';
export const TENANT_SUPPORT_URL_META_NAME = 'tenant-support-url';
const EMPTY_PPL_CONFIG = Object.freeze({
    version: '',
    minVersion: 0,
    webResourcesBuild: '',
});
export function getBootstrapConfig() {
    return typeof window !== 'undefined'
        ? (window.__PPL_CONFIG__ ?? EMPTY_PPL_CONFIG)
        : EMPTY_PPL_CONFIG;
}
//# sourceMappingURL=bootstrapConfig.js.map